import Input from "../../Control/Input";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Wrapper } from "../../Control/Flexbox";
import RefreshIcon from "@material-ui/icons/Refresh";
import { ExpandLess, ExpandMore, Remove, Add } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const Performance = (props) => {
  const { ppapData } = props;
  const [render, setRender] = useState(false);
  const [isSpecs, setIsSpecs] = useState([]);
  function handleSpec(e, index) {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    ppapData.performances[index][e.target.name] = value;
  }

  function append(where, data) {
    ppapData[where].push(data);
    setRender((prev) => !prev);
  }

  function remove(where, index) {
    if (
      window.confirm(
        "Are you sure you want to delete Performance Test Results?"
      )
    ) {
      ppapData[where].splice(index, 1);
      setRender((prev) => !prev);
    }
  }

  const hideSpecs = (index) => {
    setIsSpecs((prev) => [...prev, index]);
  };

  const openSpecs = (index) => {
    const values = [...isSpecs];
    const idx = values.indexOf(index);
    values.splice(idx, 1);
    setIsSpecs(values);
  };

  return (
    <div className="specs-container" style={{ marginBottom: "3rem" }}>
      <Wrapper>
        <DatePicker
          value={ppapData.perf_date || null}
          label="Date"
          className="date-field"
          inputVariant="filled"
          format="dd/MM/yyyy"
          onChange={(date) => {
            ppapData.perf_date = date;
            setRender((prev) => !prev);
          }}
        />
        <DatePicker
          value={ppapData.perf_approval_date || null}
          label="Approval Date"
          className="date-field"
          inputVariant="filled"
          style={{ marginLeft: "0.5rem" }}
          format="dd/MM/yyyy"
          onChange={(date) => {
            ppapData.perf_approval_date = date;
            setRender((prev) => !prev);
          }}
        />
        <Input
          type="text"
          name="perf_lab"
          label="Lab"
          onChange={(e) => {
            ppapData.perf_lab = e.target.value;
          }}
          defaultValue={ppapData.perf_lab}
        />
        <Input
          type="text"
          name="perf_sign"
          label="Signature"
          onChange={(e) => {
            ppapData.perf_sign = e.target.value;
          }}
          defaultValue={ppapData.perf_sign}
        />
      </Wrapper>
      <div>
        <Wrapper
          justify="space-between"
          style={{ borderBottom: "1px solid #c80202" }}
        >
          <p className="card-btn-para" style={{ color: "#c80202" }}>
            • ADD{" "}
            <span style={{ fontWeight: 400, color: "black" }}>
              PERFORMANCE TEST
            </span>
          </p>
          <Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#c80202",
                color: "white",
                cursor: "pointer",
              }}
              onClick={() => {
                append("performances", {
                  s_no: ppapData?.performances.length + 1,
                });
              }}
              justify="center"
            >
              <Add />
            </Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#151a1d",
                color: "white",
                cursor: "pointer",
              }}
              justify="center"
              onClick={() => {
                ppapData?.performances?.sort(
                  (a, b) => Number(a.s_no) - Number(b.s_no)
                );
                setRender((prev) => !prev);
              }}
            >
              <RefreshIcon />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </div>

      {ppapData?.performances?.map((spec, index) => (
        <div
          key={uuidv4()}
          style={{
            marginBottom: "0.3rem",
            marginTop: "0.6rem",
            padding: "0rem",
            border: "1px solid #f0f2f0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "#fafafa",
              alignItems: "center",
            }}
            className="spec-header"
          >
            <Wrapper>
              <Input
                type="Number"
                name="s_no"
                onBlur={(e) => handleSpec(e, index)}
                defaultValue={spec.s_no}
                style={{ width: "80px" }}
              />
              <Wrapper
                justify="center"
                style={{
                  marginLeft: "0.4rem",
                  fontSize: "0.9rem",
                  textTransform: "uppercase",
                }}
              >
                {spec.name_of_inst}
              </Wrapper>
            </Wrapper>
            <Wrapper>
              {isSpecs.includes(index) ? (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => openSpecs(index)}
                >
                  <ExpandLess />
                </Wrapper>
              ) : (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => hideSpecs(index)}
                >
                  <ExpandMore />
                </Wrapper>
              )}
              <Wrapper
                style={{
                  height: "45px",
                  width: "50px",
                  backgroundColor: "#151a1d",
                  color: "white",
                  cursor: "pointer",
                }}
                justify="center"
                onClick={() => remove("performances", index)}
              >
                <Remove />
              </Wrapper>
            </Wrapper>
          </div>
          {isSpecs.includes(index) && (
            <div className="specs-field">
              <Wrapper>
                <Input
                  type="text"
                  name="requ"
                  placeholder="Requirements"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.requ}
                />
                <Input
                  type="text"
                  name="test_freq"
                  placeholder="Test Frequency"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.test_freq}
                />
                <Input
                  type="text"
                  name="test_qty"
                  placeholder="Test Qty."
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.brand_name}
                />
                <Input
                  type="text"
                  name="test_cond"
                  placeholder="Test Conditions"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.test_cond}
                />
                <FormControl
                  style={{
                    width: "143px",
                    marginRight: "0.5rem",
                    marginTop: "0rem",
                    marginLeft: "0.6rem",
                  }}
                  variant="filled"
                  className="select-field"
                >
                  <InputLabel>Status</InputLabel>
                  <Select
                    name="remarks"
                    defaultValue={spec.remarks}
                    onChange={(e) => handleSpec(e, index)}
                    className="spec-select-character"
                  >
                    <MenuItem value="">None</MenuItem>
                    <MenuItem value="OK">OK</MenuItem>
                    <MenuItem value="NOT OKAY">NOT OKAY</MenuItem>
                  </Select>
                </FormControl>
              </Wrapper>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default Performance;
